var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84337 9.39543C7.57649 9.39281 7.32152 9.31214 7.13279 9.17059C6.94407 9.02904 6.8365 8.83782 6.83301 8.63766V4.09102C6.83301 3.89005 6.93946 3.69731 7.12894 3.5552C7.31842 3.41309 7.57541 3.33325 7.84337 3.33325C8.11134 3.33325 8.36833 3.41309 8.5578 3.5552C8.74728 3.69731 8.85373 3.89005 8.85373 4.09102V8.63766C8.85024 8.83782 8.74268 9.02904 8.55395 9.17059C8.36522 9.31214 8.11025 9.39281 7.84337 9.39543Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84337 12.6667C8.40138 12.6667 8.85373 12.2144 8.85373 11.6564C8.85373 11.0984 8.40138 10.646 7.84337 10.646C7.28536 10.646 6.83301 11.0984 6.83301 11.6564C6.83301 12.2144 7.28536 12.6667 7.84337 12.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.8e7af9cd59ea4d9257c87fa517bbee34.svg";
export { ForwardRef as ReactComponent };